(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["devoiler-product-assurance"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async function(event) {
  const button = event.target.closest('[data-dv-copy]');
  if (!button) return;
  const panel = button.closest('.dv-assurance');
  try {
    await navigator.clipboard.writeText(button.dataset.dvCopy);
    panel.querySelector('.dv-assurance__status').textContent = panel.dataset.copySuccess + ' ' + button.dataset.dvCopy;
  } catch (error) {
    panel.querySelector('.dv-assurance__status').textContent = button.dataset.dvCopy;
  }
});
  } catch(e) { console.error(e); }
})();

})();
